import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export default function GoalNewContentChip() {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(
        'flex justify-center items-center px-xxs rounded-xxs cursor-default P4R w-max text-nowrap',
        setupForDark('text-black bg-label-yellow')
      )}
      data-testid='goal-new-content-chip'
    >
      {t('domains.goals.newContent.marker')}
    </div>
  );
}
